import { render, staticRenderFns } from "./agent_collections.vue?vue&type=template&id=f3e778c8&"
import script from "./agent_collections.vue?vue&type=script&lang=js&"
export * from "./agent_collections.vue?vue&type=script&lang=js&"
import style0 from "./agent_collections.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports